// A source's received date (ADR-0094): when the case received it, as opposed to when it was
// uploaded. The UI declares it as a calendar day (`YYYY-MM-DD`), which the API stores as that
// day's midnight in UTC; it is shown as a day. Pure: no IO, safe for pure components.

import { formatDate } from '@/utils/date'

const pad2 = (value: number) => String(value).padStart(2, '0')

/** A day as an `<input type="date">` value, in the device's time zone. */
function dayValue(date: Date): string {
  return `${date.getFullYear()}-${pad2(date.getMonth() + 1)}-${pad2(date.getDate())}`
}

/** The `<input type="date">` value of a received date, or '' when there is none (an older server). */
export function receivedDayValue(iso: string | null | undefined): string {
  if (!iso) return ''
  const date = new Date(iso)
  return Number.isNaN(date.getTime()) ? '' : dayValue(date)
}

/** Today as an `<input type="date">` value: the latest day a source can have been received on. */
export function latestReceivedDay(now: Date = new Date()): string {
  return dayValue(now)
}

/** A received date as the reader's locale writes a day ("4 Jul 2025"), or '—' when there is none. */
export function formatReceivedDay(iso: string | null | undefined, locale: string): string {
  return receivedDayValue(iso) ? formatDate(iso as string, locale) : '—'
}
